import { removeFalsy } from "helpers/formatter";
import { TStaff } from "models/staff";
import apiService from "modules/api/apiService";
import { STAFFS } from "modules/api/endpoint";
import { TPagination } from "modules/api/type";

export const getStaffList = async (
  params: any
): Promise<{
  success: boolean;
  data?: TStaff[];
  pagination?: TPagination;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(`${STAFFS}${queryParams ? `?${queryParams}` : ""}`);

    return {
      data: results.data.payload.data,
      pagination: results.data.payload.pagination,
      success: true,
    };
  } catch (error) {
    return { success: false };
  }
};

export const getStaffDetails = async (
  staffId
): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  try {
    const result = await apiService.get(`${STAFFS}/${staffId}`);
    return {
      data: result.data.payload,
      success: true,
    };
  } catch (error) {
    return {
      message: error.message,
      success: false,
    };
  }
};

export const createStaff = async (
  body
): Promise<{
  success: boolean;
  message?: string;
  errors?: any[];
}> => {
  try {
    const results = await apiService.post(STAFFS, body);
    //console.log(`results is:\n`, results);
    return {
      success: results.data.success,
    };
  } catch (error) {
    return {
      errors: error.response.data.errors,
      message: error.response.data.message,
      success: false,
    };
  }
};

export const updateStaff = async (
  staffId,
  body
): Promise<{
  success: boolean;
  message?: string;
  errors?: any[];
}> => {
  try {
    //console.log(`In updateStaff\n`);
    //console.log(`body is:\n`, body);
    const results = await apiService.put(`${STAFFS}/${staffId}`, body);
    //console.log(`body is:\n`, body);
    //console.log(`results is:\n`, results);
    return {
      success: results.data.success,
    };
  } catch (error) {
    //console.log(`body is:\n`, error);
    return {
      errors: error.response.data.errors,
      message: error.response.data.message,
      success: false,
    };
  }
};

export const updateStaffStatus = async (
  staffId,
  body
): Promise<{
  success: boolean;
  message?: string;
  errors?: any[];
}> => {
  try {
    const results = await apiService.put(`${STAFFS}/${staffId}/status`, body);
    return {
      success: results.data.success,
    };
  } catch (error) {
    return {
      errors: error.response.data.errors,
      message: error.response.data.message,
      success: false,
    };
  }
};

export const deleteStaff = async (
  id
): Promise<{
  success: boolean;
  message?: string;
  errors?: any | any[];
}> => {
  try {
    const results = await apiService.del(`${STAFFS}/${id}`);
    return {
      success: results.data.success,
    };
  } catch (error) {
    return {
      errors: error.response.data.errors,
      message: error.response.data.message,
      success: false,
    };
  }
};
